import { useCallback } from "react";
import { useAsyncTask } from "src-next/shared/utils/useAsyncTask";
import type {
  BuildPurchaseReleaseBatchParams,
  LocalPurchaseReleaseBatch,
} from "src-next/modules/patient-supporting-documents";
import { ecommercePurchaseReleaseService } from "../services/ecommercePurchaseReleaseService";

function mapSubmitError(error: unknown): string {
  return error instanceof Error && error.message
    ? error.message
    : "Não foi possível gravar a liberação.";
}

export function useSubmitPurchaseRelease() {
  const submitTask = useCallback(
    (params: BuildPurchaseReleaseBatchParams) =>
      ecommercePurchaseReleaseService.submitPurchaseRelease(params),
    [],
  );

  const {
    run: submitRelease,
    loading: submitting,
    error: submitError,
  } = useAsyncTask<
    [BuildPurchaseReleaseBatchParams],
    LocalPurchaseReleaseBatch,
    string
  >({
    task: submitTask,
    mapError: mapSubmitError,
  });

  return { submitRelease, submitting, submitError };
}
